import { useCallback } from 'react';
import useSWR, { SWRResponse, Key, useSWRConfig } from 'swr';
import { AxiosError } from 'axios';

import {
  Parameter$getReservationFlowCourseSchemeCourses,
  Response$getReservationFlowCourseSchemeCourses$Status$200,
} from 'src/openapi/generated/apiClient';
import { useClientSideApiClient } from 'src/openapi/axiosClient';

export type UseGetReservationFlowCourseSchemeCoursesValue = SWRResponse<
  | Response$getReservationFlowCourseSchemeCourses$Status$200['application/json']
  | undefined,
  AxiosError
>;

export const getGetReservationFlowCourseSchemeCoursesKey: (params: {
  parameter: Parameter$getReservationFlowCourseSchemeCourses;
}) => Key = ({ parameter }) => {
  return {
    path: '/api/reservation_flow/merchants/{merchant_public_id}/course_scheme/resources/{resource_public_id}/courses',
    parameter,
  };
};

export const useGetReservationFlowCourseSchemeCourses: (params: {
  parameter: Parameter$getReservationFlowCourseSchemeCourses;
}) => UseGetReservationFlowCourseSchemeCoursesValue = ({ parameter }) => {
  const client = useClientSideApiClient();
  const key = getGetReservationFlowCourseSchemeCoursesKey({ parameter });

  const fetcher: () => Promise<
    | Response$getReservationFlowCourseSchemeCourses$Status$200['application/json']
    | undefined
  > = async () => {
    const result = await client.getReservationFlowCourseSchemeCourses({
      parameter,
    });

    return result;
  };

  return useSWR(key, fetcher);
};

export interface UseRevalidateGetReservationFlowCourseSchemeCoursesValue {
  revalidateGetReservationFlowCourseSchemeCourses: () => Promise<void>;
}

export const useRevalidateGetReservationFlowCourseSchemeCourses: (params: {
  parameter: Parameter$getReservationFlowCourseSchemeCourses;
}) => UseRevalidateGetReservationFlowCourseSchemeCoursesValue = ({
  parameter,
}) => {
  const { mutate } = useSWRConfig();

  const revalidateGetReservationFlowCourseSchemeCourses =
    useCallback(async () => {
      await mutate(getGetReservationFlowCourseSchemeCoursesKey({ parameter }));
    }, [parameter, mutate]);

  return { revalidateGetReservationFlowCourseSchemeCourses };
};
